<section
    class="text-bg-white"
    style="/*height: 500px;*/margin-top: 125px;margin-bottom: 40px;padding-bottom: 40px;padding-top: 22px;padding-right: 9px;padding-left: 14px;"
>
    <div class="container">
        <div class="row">
            <div class="col-md-12" style="margin-bottom: 20px;">
                <h1 class="text-center">
                    <img
                        src="assets/img/brands/LIRS_file-07.svg"
                        width="79"
                        height="71"
                    />Software center
                </h1>
                <p>
                    Abbiamo realizzato una serie di prodotti Hardware/Sofware
                    pronti all'utilizzo oppure customizzabili in base alle
                    esigenze del cliente.
                </p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3">
                <div class="card">
                    <div class="card-body">
                        <img
                            class="img-fluid"
                            src="assets/img/logoContadinoInCloud.png"
                            width="137"
                            height="137"
                            style="margin-left: 26px;"
                        />
                        <p class="text-center card-text">Contadino in cloud</p>
                        <p class="text-center text-success card-text">
                            <span style="color: rgb(96, 93, 186);"
                                >È un sistema hardware/software che permette di
                                monitorare colture da vaso o in serre.&nbsp;</span
                            >
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card">
                    <div class="card-body">
                        <img
                            class="img-fluid"
                            src="assets/img/Presino.svg"
                            width="138"
                            height="138"
                            style="text-align: center; margin-left: 25px;"
                        />
                        <p class="text-center card-text">Presino</p>
                        <p class="text-center text-success card-text">
                            <span style="color: rgb(96, 93, 186);"
                                >un sistema intelligente per rendere le case di
                                vecchia e nuova costruzione smart.</span
                            >
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card">
                    <div class="card-body">
                        <img
                            class="img-fluid"
                            src="assets/img/brands/chiamaIncloud.svg"
                            width="194"
                            height="137"
                        />
                        <p class="text-center card-text">Chiamaincloud,it</p>
                        <p class="text-center text-success card-text">
                            <span style="color: rgb(96, 93, 186);"
                                >un sistema intelligente per rendere le case di
                                vecchia e nuova costruzione smart.</span
                            >
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card">
                    <div class="card-body">
                        <img
                            class="img-fluid"
                            src="assets/img/OpenPa.png"
                            width="114"
                            height="114"
                            style="margin-left: 37px; margin-bottom: -3px;"
                        />
                        <p class="text-center card-text">openpa.app</p>
                        <p class="text-center text-success card-text">
                            <span style="color: rgb(96, 93, 186);"
                                >Tutto il software per la pubblica
                                amministrazione.</span
                            ><br /><span style="color: rgb(96, 93, 186);"
                                >portali web, totem, sistemi di monitoraggio e
                                etc.</span
                            >
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" style="margin-top: 15px;">
            <div class="col-md-3">
                <div class="card">
                    <div class="card-body">
                        <img
                            class="img-fluid"
                            src="assets/img/LogoVendo.png"
                            width="137"
                            height="137"
                            style="margin-left: 26px;"
                        />
                        <p class="text-center card-text">VENDO</p>
                        <p class="text-center text-success card-text">
                            <span style="color: rgb(96, 93, 186);"
                                >local e-commerce app. Servizio in cloud
                                dedicato alla vendita on line dei piccoli
                                negozianti e artigiani,</span
                            >
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card">
                    <div class="card-body">
                        <img
                            class="img-fluid"
                            src="assets/img/LogoConsegno.png"
                            width="138"
                            height="138"
                            style="text-align: center; margin-left: 25px; margin-bottom: 24px;"
                        />
                        <p class="text-center card-text">CONSEGNO</p>
                        <p class="text-center text-success card-text">
                            <span style="color: rgb(96, 93, 186);"
                                >Piattaforma cloud per la gestione del servizio
                                di local delivery per bar, ristoranti, pub e
                                pizzerie</span
                            >
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card">
                    <div class="card-body">
                        <img
                            class="img-fluid"
                            src="assets/img/VideoCall.png"
                            width="139"
                            height="139"
                            style="margin-left: 27px; margin-bottom: 46px;"
                        />
                        <p class="text-center card-text">MEETING</p>
                        <p class="text-center text-success card-text">
                            <span style="color: rgb(96, 93, 186);"
                                >Crea le tue video conferenze private su server
                                dedicato</span
                            >
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card">
                    <div class="card-body">
                        <img
                            class="img-fluid"
                            src="assets/img/idtap-2.png"
                            width="114"
                            height="114"
                            style="margin-left: 37px; margin-bottom: 12px;"
                        />
                        <p class="text-center card-text">IDTAP</p>
                        <p class="text-center text-success card-text">
                            <span style="color: rgb(96, 93, 186);"
                                >IDtap è "IL BIGLIETTO DA VISITA INTELLIGENTE."
                                I Biglietti idtap sono dotati di tecnologia NFC
                                integrata, condividi i tuoi contatti, mail,
                                sito, social,etc.</span
                            >
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="py-4 py-xl-5">
    <div class="container">
        <div
            class="bg-dark border rounded border-0 border-dark overflow-hidden"
        >
            <div class="row g-0">
                <div class="col-md-6">
                    <div class="text-white p-4 p-md-5">
                        <h2 class="fw-bold text-white mb-3">
                            Realizziamo soluzioni per rendere la vita più facile
                            ai nostri clienti.
                        </h2>
                        <p class="mb-4">
                            Con l’ingresso nell’era della #NextConnection e
                            grazie ad un modello di business innovativo, LIRS in
                            Italia fonda la cultura della sostenibilità, ponendo
                            al centro dell’impresa l’uomo, creando così un nuovo
                            modello
                        </p>
                        <div class="my-3">
                            <a
                                class="btn btn-primary btn-lg me-2"
                                role="button"
                                href="tel://09841830339">Chiamaci</a
                            ><a
                                class="btn btn-light btn-lg"
                                role="button"
                                href="mailto:info@lirsgroup.it">Scrivici</a
                            >
                        </div>
                    </div>
                </div>
                <div
                    class="col-md-6 order-first order-md-last"
                    style="min-height: 250px;"
                >
                    <img
                        class="w-100 h-100 fit-cover"
                        src="assets/img/Soft%20skills-rafiki.svg"
                        alt=""
                        style="background: var(--bs-tertiary-bg);"
                    />
                </div>
            </div>
        </div>
    </div>
</section>
